import { render, staticRenderFns } from "./CreateCompanyModal.vue?vue&type=template&id=45879ee4&scoped=true"
import script from "./CreateCompanyModal.vue?vue&type=script&lang=js"
export * from "./CreateCompanyModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyModal.vue?vue&type=style&index=0&id=45879ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45879ee4",
  null
  
)

export default component.exports